<script>
    export let value;
    export let id;
    export let label;
    export let width = "md:w-1/2";
</script>

<div class="w-full {width} px-3 mb-2 mt-2">
    <label class="block uppercase tracking-wide text-secondary-text text-xs font-bold mb-1" for={id}>
        {label}
      </label>

    <select bind:value={value} {id} class="w-full bg-accent-very-light text-secondary-text border border-accent-hover rounded px-3 py-3 leading-tight focus:outline-none focus:border-none focus:bg-white focus:ring-2 focus:ring-accent-border">
        <slot></slot>
    </select>
</div>
